export default "__VITE_ASSET__CWM9Ui2c__"